import React, { Fragment } from 'react';
import { TableRow } from '@mui/material';
import { TSCell, TSTable } from '../ui/TableStructure';

import dateFormatter from '../../utils/dateFormatter';
import ordinal from '../../utils/ordinal';

const ResultsByPlayerTable = ({resultsTable,playersList}) => {
	const maxPlayerPixels=800;
	const playerColumnHeaders = Array.from(playersList).map((player) => player.name);

	var results={};
	Array.from(resultsTable).forEach((result) => {
		if (results[result.date]===undefined) {
			results[result.date]={};
			results[result.date].host=result.host;
			results[result.date].games=[];
		}
		if (results[result.date].games[result.gameNumber-1]===undefined) {
			results[result.date].games[result.gameNumber-1]={};
		}
		results[result.date].games[result.gameNumber-1][result.name]=result.position;
	});

	const resultsRows = Object.keys(results).map( (date) =>  {
		return(
			<Fragment key={date}>
				{Array.from(results[date].games).map( (game,gameNum) => 
					<TableRow key={gameNum}>
						{gameNum===0 && <TSCell rowSpan={results[date].games.length}>{dateFormatter(date)}</TSCell>}
						{gameNum===0 && <TSCell rowSpan={results[date].games.length}>{results[date].host}</TSCell>}
						<TSCell>{gameNum+1}</TSCell>
						{Array.from(playersList).map((player) =>
							<TSCell sx={{width:`${(maxPlayerPixels/playersList.length).toFixed(0)}px`}} key={player.name}>{game[player.name]>0?ordinal(game[player.name]):""}</TSCell>
						)}
					</TableRow>
				)}
			</Fragment>
		)
	});

	return(
		<TSTable headings={["Date","Venue","Game",...playerColumnHeaders]}>
			{resultsRows}
		</TSTable>
	);
}

export default ResultsByPlayerTable;